<template>
    <div class="app-container pull-auto">
        <div class="menu_box">
          <div>
              <el-card class="box-card">
                    <div slot="header" class="clearfix">
                        <span>帮助中心 --- 菜单管理</span>
                    </div>
                    <el-tree
                    class="filter-tree"
                    :data="treeData"
                    node-key="id"
                    highlight-current
                    :props="defaultProps"
                    :filter-node-method="filterNode"
                    @node-click="getNodeData"
                    default-expand-all
                    >
                    </el-tree>
                </el-card>
          </div>
            <div>
            <div class="el_btn">
                <el-button size="mini"  class="filter-item filter-item1" style="margin-left: 10px;background-color: #48CC54; border:0" @click="handleCreate" type="primary"
                icon="el-icon-plus" >添加

                </el-button>
                <el-button size="mini" :disabled="derail" class="filter-item filter-item1" style="margin-left: 10px;background-color: #E6A23B; border:0" type="success"  icon="el-icon-edit-outline"
                    @click="handleUpdate1">编辑
                                </el-button>
                <el-button size="mini" :disabled="derail" class="filter-item filter-item1" style="margin-left: 10px;background-color: #F56C6C; border:0" @click="handleDelete" type="danger"
                            icon="el-icon-circle-close-outline" >删除
                </el-button>
                <el-button size="mini" :disabled="derail" class="filter-item filter-item1" style="margin-left: 10px;background-color: #48CC54; border:0" @click="handleCreate" type="primary"
                >生成静态页

                </el-button>
            </div>
                
            
           <el-table :key='tableKey'
                :data="articleMenuList"
                 @row-click = "showRow"
                border fit
                highlight-current-row
                @current-change="handleCurrentChange"
                ref="singleTable"
                style="width: 99%">
                    <el-table-column align="center" width="30px" type="index" label=" " class="part" >
                                <template slot-scope="scope">
                                    <el-radio class="radio" v-model="radio"  :label="scope.row.id" >&nbsp;</el-radio>
                                </template>
                    </el-table-column>        
                    <el-table-column align="center" label="序号" class="part" width="60px">
                    <template slot-scope="scope">
                        <!--<el-radio class="radio" v-model="radio"  :label="scope.$index"  >&nbsp;</el-radio>-->
                        <span>{{getSerialNumber(scope.$index)}}</span>
                    </template>
                    </el-table-column>
                    <el-table-column align="center" label="菜单名称">
                    <template slot-scope="scope">
                        <span>{{scope.row.name}}</span>
                    </template>
                    </el-table-column>
                    <el-table-column align="center" label="排序">
                    <template slot-scope="scope">
                        <span>{{scope.row.orderNum }}</span>
                    </template>
                    </el-table-column>
                    <el-table-column align="center" label="模板">
                    <template slot-scope="scope">
                        <span>{{scope.row.templateId }}</span>
                    </template>
                    </el-table-column>
                    <el-table-column align="center" label="表单描述">
                    <template slot-scope="scope">
                        <span>{{scope.row.tips }}</span>
                    </template>
                    </el-table-column>
            </el-table>
           </div>
        </div>
        <el-dialog
            title="添加菜单"
            :visible.sync="creatVisible"
            width="30%"
            :before-close="handleClose"
            >
            <el-form :label-position="labelPosition" label-width="80px" :model="form" :rules="rules" ref="form">
                <el-form-item label="菜单名称" prop="name">
                    <el-input v-model="form.name" :disabled="formEdit"  placeholder="请输入名称"></el-input>
                </el-form-item>
                <el-form-item label="排序" prop="orderNum">
                    <el-input v-model="form.orderNum" :disabled="formEdit" placeholder="请输入排序"></el-input>
                </el-form-item>
                <el-form-item label="选择模板" prop="templateId">
                    <el-select v-model="form.templateId" placeholder="请选择模板" clearable>
                        <el-option
                        v-for="item in templateOptions"
                        :key="item.value"
                        :label="item.name"
                        :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="菜单描述" prop="tips">
                    <el-input type="textarea" v-model="form.tips"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" size="mini" @click="create('form')">保存</el-button>
                    <el-button @click="creatVisible=false" size="mini">取消</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
        <el-dialog
            title="编辑菜单"
            :visible.sync="updateVisible"
            width="30%"
            :before-close="handleClose1">
            <el-form :label-position="labelPosition" label-width="80px" :model="updateDate" :rules="rules" ref="updateDate">
                <el-form-item label="菜单名称" prop="name">
                    <el-input v-model="updateDate.name" :disabled="formEdit"  placeholder="请输入名称"></el-input>
                </el-form-item>
                <el-form-item label="排序" prop="orderNum">
                    <el-input v-model="updateDate.orderNum" :disabled="formEdit" placeholder="请输入排序"></el-input>
                </el-form-item>
                <el-form-item label="选择模板" prop="templateId">
                    <el-select v-model="updateDate.templateId" placeholder="请选择模板" clearable>
                        <el-option
                        v-for="item in templateOptions"
                        :key="item.value"
                        :label="item.name"
                        :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="菜单描述" prop="tips">
                    <el-input type="textarea" v-model="updateDate.tips"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" size="mini" @click="update('updateDate')">修改</el-button>
                    <el-button @click="updateVisible =false" size="mini">取消</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
      
    </div>
</template>

<script>
// 查看工人信息
    import {menuList,menuInsert,menuTree,menuUpdate,menuDelete,menugetAllTemplate} from '@/api/admin/helpCenter'
    import {tableOption} from '@/const/asset/base/helpCenter'
    import {mapGetters} from 'vuex'
     import { objKeySort } from '@/util/ajaxsign'
    export default {
        name: 'manufacturerinfo',
        data() {
            return {
                templateId:'',
                templateOptions:'',
                value: '',
                deptList:[],
                radio:0,
                treeData:[],
                articleMenuList:[],
                
                // 按钮状态
                derail:true,
                form:{
                    name:'',
                    orderNum:'',
                    parentId:0,
                    templateId:'',
                    tips:''

                },
                menuId:'',
                parent:'',
                parentSon:'',
                updateDate:{},
                // 添加弹框
                creatVisible:false,
                // 修改弹框
                updateVisible:false,
                tableOption: tableOption,
                rules: {
                         name: [
                                {
                                    required: true,
                                    message: '请输入菜单名',
                                    trigger: 'blur'
                                }
                            ]
                    }
            }
        },
        created() {
            this.getTemplate()
            this.getList()
            this.articleMenu()
        },
        mounted: function () {
        },
        computed: {
            ...mapGetters(['permissions'])
        },
        methods: {
            //获取模板
            getTemplate(){
                menugetAllTemplate(objKeySort({})).then(response =>{
                    this.templateOptions=response.data.data
                })
            },
            // 当前行
             handleCurrentChange(val) {
                 console.log(val)
                 this.templateId=val.templateId
                 this.parent = val.id
                 this.updateDate=val
                 this.derail=false
                 this.value4='选项5'
             },
            getSerialNumber(index) {
                return index + 1
            },
            showRow(row,event){
              this.radio = row.id;
            },
            getNodeData(data) {
                // console.log(data.code)
                // this.menuId 
                this.menuId = data.code
                this.articleMenu()
                this.deptList = []
                var dept_id = data.id 
                var arr ='';
                for(var i=0; i<this.treeData.length;i++){
                
                if(dept_id == this.treeData[i].id){
                
                    arr=this.treeData[i].children
                }
                
                }
                this.parentSon = data.code
                // this.deptList = arr
                getchild(objKeySort({parentId:data.id})).then(response => {
                    this.deptList = arr=response.data.data
                })
       
            },
            //点击获取 菜单行数据
            handleRowClick (row, event, column) {
                console.log(row) 
              
            },
            // 菜单树
            getList() {
                 menuTree(objKeySort({})).then(response =>{
                     this.treeData =response.data.data
                    for(var i of this.treeData){
                         i.label =i.name
                         if(i.children instanceof Array){
                             for(var j of i.children){
                                 j.label =j.name
                             }
                         }
                     }
                     this.deptList = response.data.data
                 })
            },
            // 菜单列表
            articleMenu(){
                 if(this.menuId == false){
                     this.menuId =0
                 }
                menuList(objKeySort({menuId:this.menuId})).then(response =>{
                    //  console.log(response.data.data)
                     this.articleMenuList = response.data.data
                })
            },

            // 添加按钮弹框
            handleCreate(){
                // this.form.templateId = this.templateId
                this.creatVisible =true
            },
            // 编辑按钮弹框
            handleUpdate1(){
                this.form.templateId = this.templateId
                this.updateVisible =true
                
            },
            create(formName){
                   this.$refs[formName].validate((valid) => {
          if (valid) {
            if(this.parentSon==""){
                        menuInsert(objKeySort(this.form)).then(response =>{
                            location.reload()
                            this.creatVisible=false
                        })
                    }else{
                        this.form.parentId = this.parentSon
                        menuInsert(objKeySort(this.form)).then(response =>{
                            location.reload()
                            this.creatVisible=false
                        })
                    }
                    
                    
          } else {
            console.log('error submit!!');
            return false;
          }
        });
                    
                
            },
            // 修改
            update(formName){
                delete this.updateDate.$index
                if(this.updateDate.parentId ==''){
                    this.updateDate.parentId = 0
                }
                menuUpdate(objKeySort(this.updateDate)).then(response =>{
                    this.updateVisible =false
                    location.reload()
                })
            },
            // 删除
            handleDelete(){
                menuDelete(objKeySort({menuId:this.updateDate.id})).then(response=>{
                    location.reload()
                })
            },
            /**
             * 刷新回调
             */
            refreshChange() {
                this.getList()
                
            }
        }
    }
</script>

<style lang="scss" scoped>
.el_s_left{
    float:left
}
.el_btn{
    clear:both;
    padding-bottom:18px;
}
.filter-item1{
    width: auto;
    height: 40px;
    line-height: 40px;
    padding: 0 15px;
    border: 0!important;
    margin-left: 0!important;
    margin-right: 22px;
  }
 .sh_tip{
      vertical-align:top;
      display:inline-block
  }
  .lf_item span:nth-child(0){
      border:1px solid black;
      display:inline-block;
      width:100px;
  } 
  .menu_box{
      display:flex
  }
  .menu_box>div:first-child{
      width:20%;
      margin-right:1%;
  }
  .menu_box>div:last-child{
      width:80%
  }
  .el-table ::v-deep .el-table__row:nth-child(even) {
    background-color: #F6F9FF !important;
  }
  .el-dialog__body  .el-form   ::v-deep  div.el-form-item{
      width:536px;
      min-height:40px;
  }
</style>

